import { Component, OnInit, ViewChild } from '@angular/core';
import { ResizedEvent } from 'angular-resize-event';
import { SideMenuBarComponent } from '../../menu/side-menu-bar/side-menu-bar.component';
import { LocalStorageService } from '../../../local-storage.service'
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HostListener } from '@angular/core';
import { ServiceProvider } from '../../../../core/service/service.provider';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})

export class AdminLayoutComponent implements OnInit {
   
    constructor(private router: Router, private storage: LocalStorageService,private toastr: ToastrService,public dataService: ServiceProvider) { }
    sideMenuMinstatusForMain = false;
    width: number;
    height: number;
    refresh_token_interval: any = null;
    refresh_token_time = 10;
    @ViewChild(SideMenuBarComponent, { static: true }) private myChild: SideMenuBarComponent;
    onResized(event: ResizedEvent) { 
        this.width = event.newWidth;
        this.height = event.newHeight;
        var screenWidth = this.width;
        if (screenWidth < 992) {
            this.myChild.toggleResSideMenu(screenWidth);
        }
    }

   
  ngOnInit() {
    // if (!this.storage.isActiveUser()) {
    //   this.toastr.warning("Authentication is required", "Warning")
    //   this.router.navigate(['/login']);
    // }

    this.refresh_token_time = parseInt(localStorage.getItem('refresh_interval'))

    if(localStorage.getItem('refresh_interval_initiated') && this.refresh_token_interval == null){
      this.getRefreshToken()
      // this.storage.removeData('refresh_interval')
    }else{
       // this.storage.removeData('refresh_interval')
        this.refresh_token_interval = setInterval(() => {
            this.getRefreshToken()
        }, (this.refresh_token_time * 1000));
        localStorage.setItem('refresh_interval_initiated', "true")
    }
  }

  getRefreshToken(){
    this.dataService.get('RefreshAuthToken')
      .subscribe((values) => {
        console.log(new Date().toString(), values)
        // this.storage.setData("accessToken", values)
        localStorage.setItem("accessToken", values)
        if(this.refresh_token_interval == null){
          this.refresh_token_interval = setInterval(() => {
              this.getRefreshToken()
          }, (this.refresh_token_time * 1000));
        }
      }, (err) => {
        if(err.status == 401){
          this.toastr.error('Session expired!', 'Failed');
          this.storage.clearData()
          this.router.navigate(['login'])
        }
      });
  }

  @HostListener('window:focus', ['$event'])
    onFocus(event: any): void {
      this.getUserProfile()
    }

    getUserProfile(){
      this.dataService.get('GetUserProfile').subscribe((values) => {
      }, (err) => {
        if(err.status == 401){
          this.toastr.error('Session expired!', 'Failed');
          this.storage.clearData()
          this.router.navigate(['login'])
        }
      });
    }

  public getSideMenuStatus(data): void {
    this.sideMenuMinstatusForMain = data;
  }

  ngOnDestroy() {
    console.log("Admin Layout detroy")
    if (this.refresh_token_interval) {
      clearInterval(this.refresh_token_interval);
    }
  }

}
